export enum CancelOptions {
  CANCEL_AFTER_CURRENT_TERM = "cancel-after-current-term",
  CANCEL_ON_A_SPECIFIC_DATE = "cancel-on-a-specific-date",
  CANCEL_WITH_IMMEDIATE_EFFECT = "cancel-with-immediate-effect",
  DONT_CANCEL = "dont-cancel"
}
